<template>
  <div>
      <div class="app-input-row">
        <ul class="app-login-contact">
          <li>
            <p> RI DMV takes online security very seriously and authenticates every user with Multi Factor Authentication (MFA).</p>
          </li>
          <li>
            <p>Our records indicate that we have the following contact information on record for you. It is masked and displayed below. <br /></p>
            <p><strong>If you recognize it as yours</strong> <br />
              - Please select the contact information where you would like to receive a login code and click on 'NEXT'.  The login code will be valid for a limited time <br />
              - Enter the login code on the following screen <br />
              - Upon successful validation you will be navigated to your RI DMV Online Customer profile <br />
            </p>
          </li>
          <li>
            <p><strong>If you do not recognize it as yours</strong> <br />
            - Please click on 'Not my contact info' and follow the subsequent screens</p>
          </li>
        </ul>
      </div>

      <div class="app-contact-info">
        <div class="app-contact-email" v-if="contactInfo.email !=''">
          <h2 class="contact-info">Email</h2>
          <div class="app-input-row " >
            <div>
              <label class="sr-only" for="selectEmail">Select email radio button</label>
              <input type="radio" v-model="mfaType" value="2" name="conatctInfo" id="selectEmail" @change="errorMsg=''" tabindex="0">
            </div>
            <div>
              <label class="sr-only" for="myEmail">{{ myEmail }}</label>
              <input class="app-user-email" id="myEmail" type="text" v-model="myEmail" readonly disabled >
            </div>
          </div>
        </div>
        <div v-if="contactInfo.phone !=''">
          <h2 class="contact-info">Phone (Message and data rates may apply) </h2>
          <div class="app-input-row">
            <div>
              <label class="sr-only" for="selectPhone">Select phone radio button</label>
              <input type="radio" v-model="mfaType" value="1" name="conatctInfo" id="selectPhone" @change="errorMsg=''" tabindex="0">
            </div>
            <div class="phone-info">
              <div class="app-phone-number">
                <label class="sr-only" for="userPhoneAC">{{ myPhoneAC }}</label>
                <input class="contactPhone" id="userPhoneAC"  type="text" v-model="myPhoneAC" readonly disabled >
                <p>-</p>
                <label class="sr-only" for="userPhoneF3">{{ myPhoneF3 }}</label>
                <input class="contactPhone" id="userPhoneF3"  type="text" v-model="myPhoneF3" readonly disabled >
                <p>-</p>
                <label class="sr-only" for="userPhoneL4">{{ myPhoneL4 }}</label>
                <input class="contactPhone" id="userPhoneL4"  type="text" v-model="myPhoneL4" readonly disabled >
              </div>
              <div v-if="contactInfo.phone !='' && contactInfo.email ==''">
                <p>
                  <span class="phone-only-text">
                    (If this is not a cell phone # or if you cannot receive text messages at this number, 
                    <router-link to="/guest-signin?activeTab=businesspage" target="_blank" rel="noopener noreferrer" >
                      click here  
                    </router-link>
                    for a single transaction without signing in)
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <p class="error-msg" v-if="errorMsg!=''">
          {{ errorMsg }}
        </p>
        <p class="sr-only" v-if="errorMsg!=''">
          {{ errorMsg }}
        </p>
      </div>

      <BaseButtonGroup>
          <button type="button" @click="handleRouting('previous')">Previous</button>
          <CustomButton type="submit" @click="handleRouting('next')">Next</CustomButton>
          <button type="button" @click="handleRouting('noInfo')">Not my contact info</button>
      </BaseButtonGroup>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import { phoneMixin } from '@/utils/phoneMixin';
import appRouter from '@/router';
import * as COMMONS from '../../store/_commons';
import CustomButton from '../CustomButton.vue';

export default {
  name: 'ContactDetails',
  components: {
    BaseButtonGroup,
    CustomButton
  },
  data() {
    return {
      myEmail: '',

      myPhoneAC: '',
      myPhoneF3: '',
      myPhoneL4: '',

      mfaType: '',
      errorMsg: '',
      // btnDisable: false
    }
  },
  mixins: [
    phoneMixin,
  ],
  computed: {
    contactInfo() {
      return this.$store.state.guestLogin.loginUserDetails;
    }
  },
  mounted() {
    if(this.contactInfo ) {
      if(this.contactInfo.email != '') {
        this.myEmail = this.maskEmail(this.contactInfo.email || '');
      }
      if(this.contactInfo.phone != null && this.contactInfo.phone != '') {
        let phoneArr = this.contactInfo.phone.split('-');
        this.myPhoneAC = phoneArr[1]?.replace(/[&\\#, +()$~%.'":*?<>{}]/g, '');
        this.myPhoneF3 = phoneArr[2]?.replace(/\b(\d)\d|\d(?=)/g, "$1*");
        this.myPhoneL4 = phoneArr[3]?.replace(/\b()\d|\d(?=\d)/g, "$1*");
      }
    }

    window.scroll(0,0);
    document.body.setAttribute("tabindex", "1");
    document.body.focus();

    document.body.removeAttribute("tabindex");
    document.getElementById("app").scrollTop = 0;
  },
  methods: {
    ...mapActions({
      getGuestLoginMfaRequest : COMMONS.GUEST_LOGIN_GET_LOGIN_MFA_REQUEST,
    }),

    async handleRouting(info) {
      if(info=='previous') {
        appRouter.push({ path : '/guest-signin' });
      }
      else if (info=='next') {
        if(this.mfaType != '' && this.mfaType !=null) {
          let payloadData = {
            mfaType: this.mfaType,
            mfaTypeValue: this.mfaType == 1 ? this.contactInfo.phone : this.contactInfo.email
          }
          await this.getGuestLoginMfaRequest(payloadData);
        }
        else {
          this.errorMsg = 'Please select the contact information where you would like to receive the login code'
        } 
      }
      else if(info=='noInfo') {
        this.$store.state.guestLogin.mfaStep = 3;
      } 
    },

    maskEmail(str) { 
      const indexOfAt = str.indexOf('@'); 
      if (indexOfAt <= 2) { 
        return str; 
      }
      return str[0] + '*'.repeat(indexOfAt - 2) + str.substring(indexOfAt - 1);
    }
  }
}
</script>

<style lang="scss" scoped>

.app-button-group{
  margin-top: 1rem;
}

.app-input-row {
align-items: baseline;
flex-wrap: nowrap;
}
.otp{
  position: absolute;

}
.otp-text{
cursor: default !important;
.app-contact-inputs{
  margin-left: 2rem !important;
}
}
.app-required-indicator ::after {
display: none;
}

.app-contact-info{
  margin-top: 1rem;

  .contact-info{
    margin-bottom: 0.5rem;
    font-size: 1rem;
  }
  .phone-info{
    display: flex;
    gap: 1rem;
    .app-phone-number{
      display: flex;
      gap: 0.5rem;
      input {    // span injected by validator
        display: inline-block;
        padding: 0.5em;
        text-align: center;
        width: 55px;
      }
      input:last-child {
        width: 65px;    // last 4 digit
      }
    }
    .phone-only-text{
      font-weight: 500;
    }
  }

  .app-contact-email{
    margin-bottom: 2rem;
    .app-user-email{
      min-width: 375px;
    }
  }
}
.error-msg{
  color: var(--ri-red);
}

@media only screen and (max-width: 500px) {
  .app-contact-info {
    .app-contact-email{
      .app-user-email{
        min-width: 300px;
      }
    }
    .phone-info{
      display: block;
      .app-phone-number{
        display: flex;
      }
    }
  }
}
</style>

